import './scss/index.scss';
import { dcFactory } from 'dc';
import { AccountOrdersComponent } from './js/account-orders.component';

dcFactory.register(AccountOrdersComponent);
